export enum ComplianceDocumentType {
  PROOF_OF_IDENTITY = 'proof_of_identity',
  CERTIFICATE_OF_INCORPORATION = 'certificate_of_incorporation',
  SIGNED_CONTRACT = 'signed_contract',
  INSERTION_ORDER = 'insertion_order',
}
